module.exports = __webpack_public_path__ + "img/img (17).945a8c25.jpg";